<template>
  <div class="content mt-n5">
    <div class="md-layout">
      <div class="md-layout-item">
        <div class="ma-0 pa-0" style="display: flex">
          <div class="ma-0 pa-0 mt-3 mr-2">
            <v-icon @click="toggleSidebar()"> mdi-dots-vertical </v-icon>
          </div>
          <div class="ma-0 pa-0">
            <h2
              style="
                opacity: 0.8;
                font-family: Nunito Sans;
                font-size: 2rem !important;
                font-weight: 1000 !important;
              "
            >
              Share-Pages
            </h2>
          </div>
        </div>
        <div class="ma-0 pa-0">
          <div class="ma-0 pa-0 mt-n2">
            <v-flex xs12 style="font-size">
              <v-data-table
                :style="{
                  background: $vuetify.theme.themes[theme].background,
                }"
                v-model="selectedSharePages"
                :headers="headersSharePages"
                :items="sharepagesServerItems"
                :search="search"
                :single-select="singleSelect"
                multi-sort
                item-key="id"
                class="elevation-0"
                @click:row="handleClick"
              >
                <template v-slot:[`item.grids`]="{ item }">
                  <v-icon :size="item.grids.iconsize">{{
                    item.grids.icon
                  }}</v-icon>
                </template>
                <template v-slot:[`item.slug`]="{ item }">
                  <p class="ma-0 pa-0">
                    <a
                      :href="getShareLink(item.slug)"
                      target="_blank"
                      style="color: #419cff"
                      >{{ "" + baseUrl + "/sharepage/" + item.slug }}</a
                    >
                    <v-btn v-clipboard="() => getShareLink(item.slug)" icon
                      ><v-icon>mdi-content-copy</v-icon></v-btn
                    >
                  </p>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-spacer></v-spacer>
                  <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
                </template>
              </v-data-table>
            </v-flex>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

export default {
  name: "sharepages",
  components: {},
  data: function () {
    return {
      selectedSharePages: [],
      shareLink: "",
      baseUrl: "",
      headersSharePages: [
        {
          text: "Title",
          align: "start",
          value: "pagetitle",
        },

        { text: "Created", value: "created_at" },
        { text: "Arrangement", value: "grids" },
        { text: "Link", value: "slug", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
      actionClick: false,
      singleSelect: false,
      search: "",
      sharePageFiles: [
        {
          filename: "",
          version: "0",
          description: "description-fsdtfgskdjfg",
          filepng: "",
          fileglb: "../assets/images/tiefighter_02.glb",
          fileusdz: "",
        },
        {
          filename: "filenametitle",
          version: "1",
          description: "description-fsdtfgskdjfg",
          filepng: "",
          fileglb: "../assets/images/Astronaut.glb",
          fileusdz: "",
        },
        {
          filename: "filenametitle",
          version: "2",
          description:
            "description-fsdtfggk kshgfskfjgk gksdfg kjhfg kjgfdkj fgkj gkjhfg kjfgkdt iu fiutf iutf iduft kdjfg kfjgks dfhgsk djfgkfjg skdjfg",
          filepng: "",
          fileglb: "../assets/images/Soldier.glb",
          fileusdz: "",
        },
        {
          filename: "filenametitle",
          version: "3",
          description: "",
          filepng: "",
          fileglb: "../assets/images/Astronaut.glb",
          fileusdz: "",
        },
      ],
      sharepagesServerItems: [],
    };
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  mounted() {
    //this needs to be chane for online/offline
    var getUrl = window.location;
    //var baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
    this.baseUrl = getUrl.protocol + "//" + getUrl.host;

    this.getAllSharePagesFromServer();
  },

  methods: {
    getAllSharePagesFromServer() {
      //   this.fileNamesofServer = [];
      this.sharepagesServerItems = [];
      axios
        .get(this.$abServerPath + "/api/sharepages/glbgetallsharepage/", {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Token " + this.getAuthCookie("augmentableUserToken") + "",
          },
        }) //for local "/api/glb/glbgetallfile/"
        .then((response) => {
          var i;
          var len;

          var item = {
            id: "",
            slug: "",
            pagetitle: "",
            created_at: "",
            updated_at: "",
            tags: "",
            state: "",
            description: "",
            version: "",
            password_required: "",
            grids: 1,
            showFileName: false,
            showFileDescription: false,
            fileIDs: "",
          };

          for (i = 0, len = response.data.length; i < len; i++) {
            item = response.data[i];
            item.id = response.data[i].id;
            item.slug = response.data[i].slug;
            item.pagetitle = response.data[i].pagetitle;
            item.created_at = this.dateFormat(response.data[i].created_at);
            item.updated_at = response.data[i].updated_at;
            if (response.data[i].tags.charAt(0) === "[") {
              //for new tag objects
              item.tags = JSON.parse(response.data[i].tags);
            } else {
              //for previous tags when they were string not objects
              var obj = {
                title: "",
                color: "",
              };
              obj.title = response.data[i].tags;
              obj.color = "#ADD8E6";
              item.tags = [];
              item.tags.push(obj);
            }
            item.state = response.data[i].state;
            item.description = response.data[i].description;
            item.version = response.data[i].version;
            item.password_required = response.data[i].password_required;

            item.showFileName = response.data[i].showFileName;
            item.showFileDescription = response.data[i].showFileDescription;
            //string to array
            item.grids = JSON.parse(response.data[i].grids);
            item.fileIDs = JSON.parse(response.data[i].fileIDs);
            this.sharepagesServerItems.push(item);
          }
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },
    getShareLink(slug) {
      return "" + this.baseUrl + "/sharepage/" + slug;
    },
    handleClick(item) {
      if (this.actionClick === true) {
        this.actionClick = false;
        return;
      }
      console.log(item);
    },
    editItem(item) {
      this.actionClick = true;
      console.log(item.slug);
      this.goToEditSharePage(item.slug);
    },
    goToEditSharePage(slug) {
      this.$router.push({ path: "/sharepage/edit/" + slug });
    },
    deleteItem(item) {
      this.actionClick = true;
      // console.log(item.id);

      confirm("Are you sure you want to delete this item?") &&
        this.deleteServerItem(item.id);
    },
    deleteServerItem(y) {
      axios
        .delete("/api/sharepages/glbdeletesharepage/" + y + "/", {
          headers: {
            Authorization:
              "Token " + this.getAuthCookie("augmentableUserToken") + "",
          },
        })
        .then((response) => {
          console.log(response);

          this.getAllSharePagesFromServer();
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },

    dateFormat(x) {
      return (
        "" + x.slice(8, 10) + "." + x.slice(5, 7) + "." + x.slice(0, 4) + ""
      );
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      console.log(this.$sidebar.showSidebar);
    },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
</style>

